module.exports = __webpack_public_path__ + "static/img/apply_bg.3905c4d0.png";